export const documentProps = {
  title: 'Contact Us — Book a Free Discovery Call',
  description:
    'Schedule a free 30-minute discovery call with a TenK Solutions advisor. We will identify your highest-friction process and show you exactly what automation would look like for your business.',
};
